import React, {useEffect, useState} from 'react';
import {Avatar, Checkbox, Menu, Select, SelectProps, Space} from 'antd';

import {ReactComponent as SelectArrayIcon} from 'assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from 'assets/i/arrow-up-icon.svg';

import {ReactComponent as CloseFormIcon} from 'assets/form/close-form.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {setStudentsIds} from "features/model/slice/create-test/create-test-form/createTestForm";


interface Student {
    id: number;
    fullName: string;
    avatar: string;
}

interface SelectModeStudentProps {
    onSelect: (selectedStudentIds: number[]) => void;
    onClearStudents: () => void;
    setSelectedStudentId: (value: number[]) => void;
}

export const SelectModeStudent: React.FC<SelectModeStudentProps> = ({
                                                                        onSelect,
                                                                        onClearStudents,
                                                                        setSelectedStudentId
                                                                    }) => {
    const dispatch = useAppDispatch();
    const getTestData = useAppSelector(state => state.getTests.model);
    const {selectedStudentIds} = getTestData;
    const {items, pagination, error, isLoading} = useAppSelector(state => state.studentListing);

    const [open, setOpen] = useState<boolean>(false);

    const [value, setValue] = useState<number[]>(selectedStudentIds || []);


    useEffect(() => {
        if (value.length === 0) {
            onClearStudents();
        }
    }, [value]);


    const shouldAllowClear = value.length >= 3;


    useEffect(() => {
        dispatch(setStudentsIds(value));
    }, [value, dispatch]);

    const handleClear = () => {
        setValue([]);
        onSelect([])
    };


    useEffect(() => {
        setValue(selectedStudentIds || []);
        setSelectedStudentId(value)
    }, [selectedStudentIds]);


    const customClearIcon = (
        <CloseFormIcon
            onClick={() => {
                handleClear()
            }}
        />
    );


    const options: { value: number; label: React.ReactNode }[] = items.map((student: Student) => ({
        value: student.id,
        label: (
            <>
                <Avatar size={18} src={student.avatar} style={{marginRight: 8}}>
                    {student.fullName[0].toUpperCase()}
                </Avatar>
                {student.fullName}
            </>
        ),
    }));

    const selectProps: SelectProps<number[]> = {
        mode: 'multiple',
        style: {width: '100%'},
        value,
        options: options,
        onChange: (newValue: number[]) => {
            setValue(newValue);
        },
        maxTagCount: 'responsive',
        onDropdownVisibleChange: (visible) => {
            setOpen(visible);
        },
        showSearch: false,
        filterOption: false,
        tokenSeparators: [],
        dropdownRender: (menu) => (
            <Menu>
                {options.map((option) => (
                    <Menu.Item key={option.value}>
                        <Checkbox
                            checked={value.includes(option.value)}
                            onChange={() => {
                                const newValue = value.includes(option.value)
                                    ? value.filter((val) => val !== option.value)
                                    : [...value, option.value];
                                setValue(newValue);
                                onSelect(newValue);
                            }}
                            className="custom-checkbox"
                        >
                            {option.label}
                        </Checkbox>
                    </Menu.Item>
                ))}
            </Menu>
        ),
    };


    return (
        <div className="inp-box">
            <div id="select-mode">
                <Space direction="vertical" style={{width: '100%', cursor: 'pointer'}}>
                    <Select
                        {...selectProps}
                        allowClear={shouldAllowClear}
                        clearIcon={customClearIcon}
                        placeholder={<span className='placeholder-text'>Студенты</span>}
                        className={`custom-select ${open ? 'custom-select-open' : 'custom-select-closed'}`}
                        suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                    />
                </Space>
            </div>
        </div>
    );
};
